import { render, staticRenderFns } from "./textareaWork.vue?vue&type=template&id=30071b1e&"
import script from "./textareaWork.vue?vue&type=script&lang=js&"
export * from "./textareaWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports